import React, { useCallback, useEffect } from 'react';

import { Link, useLocation } from 'react-router-dom';
import { Container, Menu } from './styles';
import ButtonBack from '~/components/ButtonBack';
import Footer from '~/components/Footer';
import InputSearch from '~/components/InputSearch';

import Nexts from './Nexts';
import Realized from './Realized';
import Canceled from './Canceled';
import api from '~/services/api';

interface ILocation {
  category: string;
}

interface ITicket {
  user_id: number;
  event_id: number;
  event: string;
  slug: string;
  start_date: string;
  end_date: string;
  identifier: string;
  location: string;
  event_tab: string;
  total_quantity: string;
  available_quantity: string;
  used_quantity: string;
  canceled_quantity: string;
}

const statusByPath: Record<string, string> = {
  '/meus-ingressos/proximos': 'income',
  '/meus-ingressos/realizados': 'realized',
  '/meus-ingressos/devolvidos': 'canceled',
};

const MyTickets: React.FC = () => {
  const location = useLocation<ILocation>();
  const [filteredTickets, setFilteredTickets] = React.useState<
    ITicket[] | undefined
  >(undefined);

  useEffect(() => {
    setFilteredTickets(undefined);
  }, [location.pathname]);

  const handleSearch = useCallback(
    async (search) => {
      const status = statusByPath[location.pathname] ?? 'income';

      const response = await api.get<ITicket[]>('events/tickets', {
        params: {
          search,
          status,
        },
      });

      const filtered = search
        ? response.data.filter((item) =>
            item.event.toLowerCase().includes(search.toLowerCase())
          )
        : response.data;

      setFilteredTickets(filtered);
    },
    [location.pathname]
  );

  return (
    <Container>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="bg-white px-3 py-3 mt-3">
              <ButtonBack className="" />

              <h1 className="mt-3 mb-3">Meus Ingressos</h1>
              <div className="d-flex">
                <InputSearch
                  className="py-1 flex-auto input-search"
                  onSearch={handleSearch}
                />
              </div>
            </div>
          </div>
          <div className="col-12">
            <Menu>
              <div className="bg d-flex justify-content-between px-3 mt-3">
                <Link
                  to={`${process.env.PUBLIC_URL}/meus-ingressos/proximos`}
                  className={`${
                    location.pathname === '/meus-ingressos/proximos' && 'active'
                  }`}
                >
                  Próximos
                </Link>
                <Link
                  to={`${process.env.PUBLIC_URL}/meus-ingressos/realizados`}
                  className={`${
                    location.pathname === '/meus-ingressos/realizados' &&
                    'active'
                  }`}
                >
                  Realizados
                </Link>
                <Link
                  to={`${process.env.PUBLIC_URL}/meus-ingressos/devolvidos`}
                  className={`${
                    location.pathname === '/meus-ingressos/devolvidos' &&
                    'active'
                  }`}
                >
                  Devolvidos
                </Link>
              </div>
            </Menu>
          </div>
          <div className="col-12 px-0">
            {location.pathname === '/meus-ingressos/proximos' && (
              <Nexts externalTickets={filteredTickets} />
            )}
            {location.pathname === '/meus-ingressos/realizados' && (
              <Realized externalTickets={filteredTickets} />
            )}
            {location.pathname === '/meus-ingressos/devolvidos' && (
              <Canceled externalTickets={filteredTickets} />
            )}
          </div>
        </div>
      </div>
      <Footer />
    </Container>
  );
};

export default MyTickets;
